<script lang="ts">
    import {assets as assetPath} from '$app/paths'
    export let link : string
    export let linkText : string
    export let showArrow : boolean = false
    export let className : string = ''
</script>

<a href={link} class="page__link {className}">{linkText} {#if showArrow}<img src="{assetPath}/assets/blue-arrow.svg" alt="link arrow">{/if}</a>

<style lang="postcss">
    .page__link {
        display: flex;
        align-items: center;
        gap:8px;
        color:var(--color_offerzen_cerulean);
        text-decoration: none;
        font-weight:600;
        font-size:16px;
        line-height: 0%;

        & img {
            height:15px;
            transition: margin .5s;
        }

        &:hover img {
            margin-left:3px;
        }
    }
</style>